import { throttle } from 'lodash';

export default {
    mounted() {
        this.isMounted = true;
        this.initScrollBar();
    },
    deactivated() {
        this.isMounted = false;
        this.destory();
    },
    beforeDestroy() {
        this.destory();
    },
    activated() {
        if (this.isMounted) return;
        this.initScrollBar();
    },
    watch: {
        // 兼容一个组件里有tab页签，并且有两个table组件
        tableRefName() {
            this.destory();
            setTimeout(() => {
                this.initScrollBar();
            }, 200);
        },
    },
    computed: {
        // 如果是公共组件mTable，需要通过props传入参needScrollBar为true才生效，手动添加到页面的默认生效
        isNeedScrollBar() {
            return this.$options.name !== 'mTable' || this.needScrollBar;
        },
    },
    methods: {
        initScrollBar() {
            if (!this.isNeedScrollBar) return;
            console.log('初始化');
            const tableRefName = this.tableRefName || 'iTable'; // 兼容没用使用公共组件的页面，需要在页面上定义表格的ref名称。
            const el = this.$refs[tableRefName].$el;
            if (!el) {
                setTimeout(() => {
                    this.initCount += 1;
                    if (this.initCount > 3) {
                        return;
                    }
                    this.initScrollBar();
                }, 1000);
                return;
            }
            this.hasBottom = el.querySelector('.m-table-fixed-right-header'); // 表格底部的一个高度
            const tableBodyWrapper = el.querySelector('.m-table-body');
            this.createScroll(tableBodyWrapper);
            el.appendChild(this.dom);
            el.horizontalScroll = this.scroller;

            if (this.mode === 'hover') {
                el.addEventListener('mouseover', this.showBar);
                el.addEventListener('mouseleave', this.hideBar);
            } else {
                this.showBar();
            }
            // resize
            window.addEventListener(
                'resize',
                () => {
                    // 重置elTable-scroll-bar
                    this.resetTableScrollBar();
                },
                true,
            );
        },

        /**
         * 给tableBody创建一个scroller
         * @param {Element} targetTableWrapperEl
         * @param {string} mode
         */
        createScroll(targetTableWrapperEl) {
            const that = this;
            console.log('createScroll', targetTableWrapperEl);
            if (!targetTableWrapperEl) {
                throw new Error('need have table element');
            }
            this.targetTableWrapperEl = targetTableWrapperEl;
            /**
             * 创建相关dom
             */
            const scroller = document.createElement('div');
            scroller.classList.add('el-scrollbar');
            scroller.style.height = this.domHeight;
            scroller.style.position = 'fixed';
            scroller.style.bottom = 0;
            scroller.style.zIndex = 300;
            scroller.style.background = '#f1f1f1';
            scroller.style.boxShadow = '0px -1px 0px 0px #f1f1f1';
            scroller.style.transition = 'height 0.3s';

            this.dom = scroller;
            this.resetScroller();

            const bar = document.createElement('div');
            bar.classList.add('el-scrollbar__bar', 'is-horizontal');
            bar.style.height = this.domHeight;
            bar.style.transition = 'height 0.3s';
            this.bar = bar;
            scroller.appendChild(bar);

            const thumb = document.createElement('div');
            thumb.classList.add('el-scrollbar__thumb');
            thumb.style.borderRadius = this.domHeight;
            thumb.style.backgroundColor = '#cdcdcd';
            thumb.style.cursor = 'unset';
            thumb.style.height = '100%';
            thumb.style.transition = 'height 0.3s';
            thumb.onmouseover = () => {
                scroller.style.height = this.domHeightHover;
                thumb.style.height = this.domHeightHover;
                bar.style.height = this.domHeightHover;
            };
            thumb.onmouseout = () => {
                if (this.isMoving) return;
                scroller.style.height = this.domHeight;
                thumb.style.height = this.domHeight;
                bar.style.height = this.domHeight;
            };
            bar.appendChild(thumb);
            this.thumb = thumb;

            this.checkIsScrollBottom();

            // 全局判断是否需要显示scroller
            const scrollContainer = document.querySelector('.layout-main');
            scrollContainer.addEventListener('scroll', this.checkIsScrollBottom, true);

            // 自动同步,table => scroller
            this.targetTableWrapperEl.addEventListener(
                'scroll',
                throttle(() => {
                    that.resetThumbPosition();
                }, 1000 / 60),
            );

            // 自动同步 scroller => table
            this.syncDestoryHandler = this.initScrollSyncHandler();

            // 监听table的dom变化，自动重新设置
            this.tableElObserver = new MutationObserver(() => {
                setTimeout(() => {
                    that.resetTableScrollBar();
                });
            });
            this.tableElObserver.observe(targetTableWrapperEl.querySelector('.m-table-tbody'), {
                childList: true,
                subtree: true,
                attributes: false,
            });
            // 重置elTable-scroll-bar
            setTimeout(() => {
                that.resetTableScrollBar();
            }, 500);
        },

        checkIsScrollBottom: throttle(function () {
            const that = this;
            const viewHeight = window.innerHeight || document.documentElement.clientHeight;
            const { bottom } = that.targetTableWrapperEl.getBoundingClientRect();
            // console.log(2222, bottom, viewHeight);
            if (bottom <= viewHeight) {
                that.hideScroller();
            } else {
                // 需要重新设置一次当前宽度
                that.resetBar(false);

                // 显示当前的bar
                that.showScroller();
            }
        }, 1000 / 60),

        /**
         * 自动设置Bar
         * @param {boolean} changeScrollerVisible 是否开启自动设置滚动条显示与否
         */
        resetBar(changeScrollerVisible = true) {
            const { targetTableWrapperEl } = this;
            const widthPercentage = (targetTableWrapperEl.clientWidth * 100) / targetTableWrapperEl.scrollWidth;
            const thumbWidth = Math.min(widthPercentage, 100);
            this.thumb.style.width = `${thumbWidth}%`;

            this.fullwidth = thumbWidth >= 100;

            if (changeScrollerVisible) {
                if (this.fullwidth) {
                    this.hideScroller();
                } else {
                    this.checkIsScrollBottom();
                }
            }
        },

        resetThumbPosition() {
            this.thumb.style.transform = `translateX(${this.moveX()}%)`;
        },

        resetScroller() {
            const { targetTableWrapperEl, dom } = this;
            const boundingClientRect = targetTableWrapperEl.getBoundingClientRect();
            dom.style.left = `${boundingClientRect.left}px`;
            dom.style.width = `${boundingClientRect.width}px`;
        },

        moveX() {
            const { targetTableWrapperEl } = this;
            return (targetTableWrapperEl.scrollLeft * 100) / targetTableWrapperEl.clientWidth;
        },
        /**
         * 让scroller的拖动行为和table的同步
         * 处理类似element-ui的拖拽处理
         */
        initScrollSyncHandler() {
            let cursorDown = false;
            let tempClientX = 0;
            let rate = 1;

            const { thumb, targetTableWrapperEl, bar } = this;

            function getRate() {
                // 计算一下变换比例，拖拽走的是具体数字，但是这个实际上应该是按照比例变的
                return bar.offsetWidth / thumb.offsetWidth;
            }

            const mouseMoveDocumentHandler = throttle(
                /** @param {MouseEvent} e */
                (e) => {
                    if (cursorDown === false) {
                        return;
                    }
                    const { clientX } = e;
                    const offset = clientX - tempClientX;
                    const originTempClientX = tempClientX;
                    tempClientX = clientX;

                    const tempScrollleft = targetTableWrapperEl.scrollLeft;
                    targetTableWrapperEl.scrollLeft += offset * rate;
                    if (tempScrollleft === targetTableWrapperEl.scrollLeft) {
                        tempClientX = originTempClientX;
                    }
                },
                1000 / 60,
            );
            /** @param {MouseEvent} e */
            const mouseUpDocumentHandler = () => {
                cursorDown = false;
                this.isMoving = false;
                this.dom.style.height = this.domHeight;
                this.thumb.style.height = this.domHeight;
                this.bar.style.height = this.domHeight;
                document.removeEventListener('mousemove', mouseMoveDocumentHandler);
                document.removeEventListener('mouseup', mouseUpDocumentHandler);
                document.onselectstart = null;
            };

            /**
             * 拖拽处理
             * @param {MouseEvent} e
             */
            function startDrag(e) {
                e.stopImmediatePropagation();
                cursorDown = true;
                document.addEventListener('mousemove', mouseMoveDocumentHandler);
                document.addEventListener('mouseup', mouseUpDocumentHandler);
                document.onselectstart = () => false;
            }

            thumb.onmousedown = (e) => {
                // prevent click event of right button
                if (e.ctrlKey || e.button === 2) {
                    return;
                }
                this.isMoving = true;
                const { clientX } = e;
                tempClientX = clientX;
                rate = getRate();
                startDrag(e);
            };

            /**
             * 点击槽快速移动
             * @param {PointerEvent} e
             */
            bar.onclick = function (e) {
                const { target } = e;
                if (target !== bar) {
                    return;
                }
                rate = getRate();
                const { clientX } = e;
                let offset = 0;
                const thumbPosition = thumb.getBoundingClientRect();
                if (thumbPosition.left >= clientX) {
                    offset = clientX - thumbPosition.left;
                } else {
                    offset = clientX - thumbPosition.left - thumbPosition.width;
                }

                const targetScrollLeft = targetTableWrapperEl.scrollLeft + offset * rate;
                targetTableWrapperEl.scrollTo({
                    left: targetScrollLeft,
                    behavior: 'smooth',
                });
            };

            return function () {
                document.removeEventListener('mouseup', mouseUpDocumentHandler);
            };
        },
        /**
         * 显示整体
         */
        showScroller() {
            if (!this.fullwidth) {
                this.dom.style.display = 'initial';
                this.dom.style.position = 'fixed';
                this.dom.style.bottom = '0';
                this.resetScroller();
            }
        },

        /**
         * 隐藏整体
         */
        hideScroller() {
            if (this.mode === 'force') {
                this.mode.style.display = 'initial';
            } else {
                this.dom.style.position = 'absolute';
                this.dom.style.left = '0';
                this.dom.style.bottom = this.hasBottom ? '33px' : '-10px';
            }
        },
        /**
         * 显示滚动条
         */
        showBar() {
            this.bar.style.opacity = 1;
        },

        /**
         * 隐藏滚动条
         */
        hideBar() {
            if (this.mode === 'force') {
                this.bar.style.opacity = 1;
            } else {
                this.bar.style.opacity = 0;
            }
        },

        // 重置elTable-scroll-bar
        resetTableScrollBar() {
            this.resetBar();
            this.resetScroller();
            this.resetThumbPosition();
            this.checkIsScrollBottom();
        },

        destory() {
            if (!this.isNeedScrollBar) return;
            console.log('destory');
            this.hideBar();
            this.tableElObserver.disconnect();
            const scrollContainer = document.querySelector('.layout-main');
            scrollContainer.removeEventListener('scroll', this.checkIsScrollBottom, true);
            window.removeEventListener(
                'resize',
                () => {
                    // 重置elTable-scroll-bar
                    this.resetTableScrollBar();
                },
                true,
            );
            this.syncDestoryHandler();
        },
    },
    data() {
        return {
            mode: 'always', // 有两种模式  always / hover
            targetTableWrapperEl: null,
            fullwidth: false,
            dom: null,
            bar: null,
            thumb: null,
            tableElObserver: null,
            syncDestoryHandler: null,
            initCount: 0,
            domHeight: '20px',
            domHeightHover: '20px',
        };
    },
};
